import { render, staticRenderFns } from "./RecentTransactionList.vue?vue&type=template&id=d866cfc2"
import script from "./RecentTransactionList.vue?vue&type=script&lang=js"
export * from "./RecentTransactionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports